{
  "el": {
    "dashboard": {
      "greetings": {
        "afternoon": "Καλό απόγευμα {first_name}",
        "evening": "Καλησπέρα {first_name}",
        "morning": "Καλημέρα {first_name}",
        "night": "Καληνύχτα {first_name}"
      },
      "milestones": {
        "action_title_decision": "Επίλεξε {name}",
        "action_title_survey": "Συμπλήρωσε {name}",
        "action_title_ticket": "Νέο μήνυμα σχετικά με {name}",
        "count_open": "{count} σε εκκρεμότητα",
        "journey_hide": "Απόκρυψη της διαδρομής του έργου",
        "journey_show": "Δείτε τη διαδρομή του έργου",
        "journey_step_active": "Σε εξέλιξη",
        "journey_step_completed": "Ολοκληρώθηκε",
        "journey_step_planned": "Προγραμματισμένη",
        "other_empty_subtitle": "Η {client} θα σε ενημερώσει μόλις υπάρξει κάτι για σένα.",
        "other_empty_title": "Είσαι πλήρως ενημερωμένος",
        "other_promoted_title": "Χρειάζεται την προσοχή σου",
        "other_title": "Άλλες ενέργειες",
        "stage_done_subtitle": "Η {client} θα σε ενημερώσει όταν έρθει το επόμενο βήμα.",
        "stage_done_title": "Όλα έτοιμα για αυτή τη φάση",
        "stage_empty": "Αυτή τη στιγμή δεν υπάρχει κάτι να κάνεις σε αυτή τη φάση.",
        "stage_eyebrow": "Τρέχουσα φάση",
        "stage_final_subtitle": "Όλα τα βήματα του έργου σου έχουν ολοκληρωθεί. Θα σε κρατάμε ενήμερο αν κάτι αλλάξει.",
        "stage_final_title": "Είσαι εντελώς έτοιμος",
        "stage_last": "Αυτή είναι η τελευταία φάση",
        "stage_next": "Επόμενο: {phase}",
        "stage_position": "Φάση {current} από {total}",
        "stage_todo_title": "Για να ολοκληρώσεις αυτή τη φάση"
      },
      "titles": {
        "activityFeed": "Ιστορικό",
        "assignedTasks": "Οι εργασίες μου",
        "newsFeed": "Ανακοινώσεις",
        "ongoingTickets": "Σε εξέλιξη",
        "openTickets": "Ανοιχτές",
        "progress": "Πρόοδος",
        "tickets": "Συνομιλίες",
        "totalTickets": "Όλες οι συνομιλίες",
        "unreadTickets": "Μη αναγνωσμένες",
        "yourAssignedTickets": "Ανατεθειμένες σε σένα"
      }
    }
  }
}
